import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import AlumniAll from 'components/NextconLabAlumni/AlumniAll';
import { useEffect } from "react";

function Alumni() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <AlumniAll />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <AlumniAll />
        <Footer />
      </>
    )}
    </>
  );
}

export default Alumni;

/*

  <GradAlumni />
  <hr />
  <PostdocAlumni />
  <hr />
  <UndergradAlumni />

*/